import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { DataGrid } from "../../components";
import { DataGridButtonProps } from "../../components/data-grid/types";
import { getLocalized } from "../../redux/localization";
import { accountUrl, createUserUrl } from "../../services/urls";
import CreateUserForm from "./create";
const AccountPage = () => {
  const localize = useSelector(getLocalized);
  const history = useHistory();
  const columns = [
    {
      dataField: "AccountName",
      caption: localize.getString("accountname"),
    },
    {
      dataField: "AccountType",
      caption: localize.getString("accounttype"),
    },
    {
      dataField: "Description",
      caption: localize.getString("description"),
    },
    {
      dataField: "Note",
      caption: localize.getString("note"),
    },
    {
      dataField: "CreateTime",
      caption: localize.getString("creationtime"),
      dataType: "date",
    },
  ];
  const buttons: DataGridButtonProps[] = [
    {
      hint: "info",
      icon: "info",
      onClick: function (e: any) {
        history.push(`/account-details/${e.row.data.Id}`);
      },
    }
  ];


  return (
    <>
      
      <DataGrid

        buttons={buttons}
        getByIdUrl={accountUrl}
        url={accountUrl}
        
        columns={columns || []}
        refObject={
          {}
        }
        // details={{
        //   width: "35%",
        //   height: "62%",
        //   getByIdUrl: "api/AppUser",
        //   title: "Kullanıcı Detayları",
        //   component: DetailUserForm,
        // }}
        // edit={{
        //   width: "35%",
        //   height: "62%",
        //   editUrl: userUrl,
        //   title: "Kullanıcı Düzenle",
        //   component: EditUserForm,
        //   validationGroup: "editUserFormValidation",
        // }}
        create={{
          width: "50%",
          height: "60%",
          createUrl: createUserUrl,
          title: "Hesap Ekle",
          component: CreateUserForm,
          validationGroup: "createUserFormValidation",
          isJson : true
        }}
      //   remove={{ url: modelUrl }}
      />
    </>
  );
};
export default AccountPage;
